<template>

    <!--

        Reserva necessária
        Aporte mensal necessário

    -->
    <div class="container" v-if="independencia_financeira">
        <div>
            <div class="simulator-box card-panel">
                <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">Independência
                    Financeira</h2>

                <input-simulador input-type="number"
                    label="Qual é a idade que deseja se aposentar ou se tornar financeiramente independente?"
                    max="89"
                    @input="salvar" icon="person" v-model="independencia_financeira.idade_aposentadoria" />


                <input-simulador icon="person">
                    <p slot="input">
                        {{ idade }} anos <br>
                    </p>
                    <label slot="label">
                        Idade Atual
                        (<a class="link" @click.prevent="() => modal_data_nascimento = true" href="#">Modificar data de nascimento</a>)
                    </label>
                </input-simulador>

                <input-simulador input-type="price"
                    label="De acordo com seu objetivo, qual é a renda complementar necessária para manter esse padrão de vida?"
                    @input="salvar" v-model="independencia_financeira.renda_complementar" />

                <input-simulador input-type="price" label="Qual é o valor acumulado hoje para esse objetivo?"
                    @input="salvar" v-model="independencia_financeira.valor_acumulado" />

                <input-simulador label="Reserva estimada necessária para a realização desse objetivo" @input="salvar">
                    <p slot="input">
                        {{ reservaNecessaria | dinheiro }}
                    </p>
                </input-simulador>

                <input-simulador input-type="price" label="Aporte inicial" @input="salvar"
                    v-model="independencia_financeira.aporte_inicial" />

            </div>

            <div class="simulator-box card-panel">

                <p>
                    <strong>Aporte mensal necessário para a realização desse objetivo</strong>
                </p>


                <div class="flex-row item-checkbox" v-for="(valor, index) in rentabilidadesPadroes" :key="index">
                    <div class="col-xs">
                        <input @change="salvar" :id="`rent-${index}`" name="rentabilidade_estimada" type="radio" :value="valor"
                            v-model="rentabilidade_estimada" :disabled="valoresRentabilidadesPadroes[index] < 0" />
                        <label :for="`rent-${index}`">{{ valor }}%</label>
                    </div>
                    <div class="col-xs" :class="{'text-active' : rentabilidade_estimada == valor}">
                        <template v-if="valoresRentabilidadesPadroes[index] > 0">
                            {{ valoresRentabilidadesPadroes[index] | dinheiro }}
                        </template>
                        <span v-else class="red-text lighten-3">
                            Você não precisa fazer um investimento mensal.
                        </span>
                    </div>
                </div>

                <div class="flex-row item-checkbox">
                    <div class="col-xs">
                        <input id="rent-outros" name="rentabilidade_estimada" type="radio" :checked="!rentabilidadesPadroes.includes(rentabilidade_estimada)" />
                        <label for="rent-outros">
                            <input @input="salvar" type="number" id="input-rentabilidade" v-model="rentabilidade_estimada"
                                class="form-control" min="1" max="100">%
                        </label>
                    </div>
                    <div class="col-xs">
                        <span v-if="aporte > 0" :class="{'text-active' : rentabilidadePersonalidada}">
                            {{ aporte | dinheiro }}
                        </span>
                        <span v-else class="red-text lighten-3">
                            Você não precisa fazer um investimento mensal.
                        </span>
                    </div>
                </div>

            </div>

            <footer-simulador :loading.sync="carregando" />
        </div>


        <modal :is-active.sync="modal_data_nascimento" title="Cadastrar data de nascimento">
            <form @submit.prevent="salvarDataNascimento()">
                <div>
                    <label>É necessário informar a data de nascimento do cliente para continuar fazer o cáĺculo da
                        independência financeira</label>
                    <div class="flex-row middle-xs">
                        <div class="col-xs">
                            <div class="input-fiel">
                                <masked-input mask="11/11/1111" v-model="data_nascimento" class="form-control" />
                            </div>
                        </div>
                        <div class="col-xs flex-no-grow">
                            <button class="btn btn-default">
                                Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>


<script>

import { api } from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import debounce from "lodash/debounce";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

import calculadora from '@/helpers/calculadora.js';
import MaskedInput from "vue-masked-input";

import Modal from '@/components/common/Modal/Base.vue'

import {presente_value, pgto} from "@/helpers/calculo_financeiro"

export default {

    components: { InputSimulador, SvgPercentage, TotalSimulador, MaskedInput, FooterSimulador, Modal },

    name: 'independente-financeira',

    async mounted() {

        let { id } = this.$route.params;

        let { data: { result: { data: cliente } } } = await api.get(`cliente/${id}`);


        const campos_float = [
            'renda_complementar',
            'valor_acumulado',
            'aporte_inicial',
            'rentabilidade_estimada',
            'necessidade_investimento'
        ];

        if (cliente.independencia_financeira) {

            campos_float.forEach(key => {

                if (cliente.independencia_financeira) {
                    cliente.independencia_financeira[key] = parseFloat(cliente.independencia_financeira[key] || 0);
                }
            })
        }

        const independencia_financeira = {
            rentabilidade_estimada: 3,
            renda_complementar: 0,
            valor_acumulado: 0,
            aporte_inicial: 0,
            necessidade_investimento: 0,
            idade_aposentadoria: null,
            ...cliente.independencia_financeira,
            cliente_id: cliente.cliente_id
        };

        this.cliente = cliente;
        this.independencia_financeira  = independencia_financeira;
        this.rentabilidade_estimada = this.independencia_financeira.rentabilidade_estimada;

        if (cliente.pessoa.pessoa_data_nascimento) {
            this.data_nascimento = moment(cliente.pessoa.pessoa_data_nascimento).format("DD/MM/YYYY");
        } else {
            this.modal_data_nascimento = true;
        }


        await this.$nextTick();
    },

    computed: {

        idade() {
            return Math.floor(
                moment().diff(moment(this.data_nascimento, "DD/MM/YYYY"), "years", true)
            )
        },

        rentabilidadePersonalidada() {
            return !this.rentabilidadesPadroes.includes(this.rentabilidade_estimada);
        },

        aporte() {
            return this.calcularRentabilidadeEstimada(this.rentabilidade_estimada);
        },

        rentabilidadesPadroes() {
            return [3, 4, 6];
        },

        valoresRentabilidadesPadroes() {
            return this.rentabilidadesPadroes.map(v => this.calcularRentabilidadeEstimada(v));
        },


        reservaNecessaria() {

            const rate = this.calcularTaxaEfetivaMensal(this.rentabilidade_estimada);

            const nper = (90 - this.independencia_financeira.idade_aposentadoria) * 12;

            const pmt  = -this.independencia_financeira.renda_complementar;

            return -presente_value(rate, nper, pmt);
        },

        porcentagem() {
            let soma_porcentagem = 0;

            ['custos_judiciais', 'imposto_itcd', 'advogados'].forEach(key => {

                let num = parseFloat(this.independencia_financeira[key]);

                soma_porcentagem += isNaN(num) ? 0 : num;

            });


            return soma_porcentagem;
        },

        soma() {

            let keys = [
                "imoveis",
                "veiculos",
                "investimentos",
                "maquinas_equipamentos",
                "saldos_bancarios",
                "outros"
            ];

            let total = 0;

            keys.forEach(key => {

                let num = parseFloat(this.independencia_financeira[key]);

                total += isNaN(num) ? 0 : num;
            })

            return total;
        },
    },

    data() {
        return {
            cliente: null,
            independencia_financeira: null,
            rentabilidade_estimada: null,
            carregando: false,
            data_nascimento: null,


            modal_data_nascimento: false,
        };
    },


    methods: {


        calcularTaxaEfetivaMensal(porcentagem) {

            return (((porcentagem * 0.01) + 1) ** (1/12) - 1)
        },


        calcularRentabilidadeEstimada(rentabilidade) {

            if (!this.cliente) return;

            const prazo_acumulacao = (this.independencia_financeira.idade_aposentadoria - this.idade) * 12;

            const taxa_efetiva_mensal = this.calcularTaxaEfetivaMensal(rentabilidade) ;

            return -1 * pgto(prazo_acumulacao, taxa_efetiva_mensal, -this.independencia_financeira.aporte_inicial, this.reservaNecessaria)
        },

        salvar: debounce(async function () {

            if (this.aporte < 0) return;

            this.carregando = true;

            const dados = {
                ...this.independencia_financeira,
                necessidade_investimento: this.aporte
            }

            try {
                await api.put('independencia-financeira', dados);
            } finally {
                setTimeout(() => this.carregando = false, 2000);
            }

        }, 500),


        async salvarDataNascimento() {

            let dados = {
                ...this.cliente.pessoa,
                pessoa_data_nascimento: moment(this.data_nascimento, "DD/MM/YYYY").format("YYYY-MM-DD")
            };


            let { data: { result: { data: cliente } } } = await api.put(`cliente/${this.cliente.cliente_id}`, dados);

            this.cliente = { ...this.cliente, ...cliente };


            this.modal_data_nascimento = false
        }
    },


    watch: {


        'independencia_financeira.valor_acumulado'(valor) {
            let { aporte_inicial } = this.independencia_financeira;

            this.independencia_financeira.aporte_inicial = valor
        },

        rentabilidade_estimada(valor, anterior) {

            this.independencia_financeira.rentabilidade_estimada = valor;

            // anterior == null || this.salvar();
        }
    }
}
</script>


<style lang="scss" scoped>

#input-rentabilidade {

    margin: 0;
    height: auto;
    width: 40px;
    padding: 5px;


    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}


.text-active {
    color: var(--color-primary);
    font-weight: bold;
}

.item-checkbox {
    padding: 10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/clientes/IndependenciaFinanceira.vue